// @tennis-matches/clubmeisterschaft-core/ko – Qualifier resolver v1 (pure)

/**
 * Fill schedule.ko.slots[].entrant with real pid from group rankings.
 * v1: only groupPlace slots are filled; bestThird remains tbd.
 * @param {object} input
 * @param {object} input.schedule built schedule (with ko.slots)
 * @param {object} input.groupRankings result of buildGroupRankings
 * @param {object} input.groupsKo groupsKo config (or use schedule.config)
 * @returns {object} new schedule with ko.slots updated
 */
export function resolveKoEntrants({ schedule, groupRankings, groupsKo }) {
  const gk = groupsKo || schedule?.config || {};
  const advancePerGroup = Number(gk.qualification?.advancePerGroup ?? gk.advancePerGroup ?? 2);

  const slots = (schedule?.ko?.slots || []).map((s) => {
    const entrant = s.entrant || {};
    if (entrant.slotType === "groupPlace") {
      const gid = entrant.groupId;
      const place = Number(entrant.place || 0);
      const ranking = groupRankings?.[gid]?.rows || [];
      const row = ranking[place - 1];
      if (row?.pid) {
        return { ...s, entrant: { ...entrant, pid: row.pid } };
      }
    }
    return s;
  });

  return { ...schedule, ko: { ...schedule?.ko, slots } };
}
